<template>
  <div class="education-page" v-if="translations">
    <template v-if="!isLoading">
      <div class="education-page__container">
        <h1 class="education-page__heading">{{ page.title }}</h1>

        <div
          class="education-page__description cms-content"
          v-html="page.content"
          v-on:click="handleContentClick($event)"
        ></div>
      </div>

      <section class="education-page__child-pages" v-if="articles">
        <h2 class="education-page__child-pages-heading">
          {{ translations.catagories.section }}
        </h2>

        <ul class="education-page__child-pages-list">
          <li
            class="education-page__child-pages-list-item"
            v-for="child_page in articles"
            :key="child_page.documentId"
          >
            <router-link
              :to="{
                name: 'education_article',
                params: { id: child_page.documentId },
              }"
              class="education-page__child-pages-list-item-link"
            >
              {{ child_page.title }}
            </router-link>
          </li>
        </ul>
      </section>

      <WasThisUseful
        v-if="page.id"
        :title="page.title"
        :id="page.id.toString()"
        :type="'education'"
      />
    </template>
    <template v-else>
      <v-container>
        <div class="education-page__loading">
          <LoadingSpinner :spinner-text="translations.toolkit.loading" />
        </div>
      </v-container>
    </template>
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";
import LoadingSpinner from "../components/App/LoadingSpinner.vue";
import WasThisUseful from "@/components/WasThisUseful/WasThisUseful";

export default {
  components: {
    LoadingSpinner,
    WasThisUseful,
  },
  data() {
    return {
      page: [],
      articles: [],
      isLoading: false,
    };
  },
  computed: {
    translations() {
      return hubbdata.getters.translations;
    },
  },
  methods: {
    async educationPage() {
      this.isLoading = true;
      try {
        const params = new URLSearchParams({
          populate: "*",
          locale: localStorage.getItem("current_lang"),
        });

        const response = await fetch(
          `https://mentalhealthhub.focusgov.co.uk/api/further-education?${params}`,
          {
            method: "GET",
            mode: "cors",
            credentials: "omit",
            headers: {
              Accept: "application/json",
            },
          }
        );
        const data = await response.json();
        this.page = data.data;
      } catch (err) {
        this.page = [];
      } finally {
        this.isLoading = false;
      }
    },
    async childPages() {
      this.isLoading = true;
      try {
        const params = new URLSearchParams({
          populate: "*",
          locale: localStorage.getItem("current_lang"),
        });
        const response = await fetch(
          `https://mentalhealthhub.focusgov.co.uk/api/educations?${params}`,
          {
            method: "GET",
            mode: "cors",
            credentials: "omit",
            headers: {
              Accept: "application/json",
            },
          }
        );
        const data = await response.json();
        this.articles = data.data;
      } catch (error) {
        this.articles = [];
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.educationPage();
    this.childPages();

    this.$bus.$on("language-changed-from-header", () => {
      this.educationPage();
      this.childPages();
    });
  },
};
</script>

<style lang="scss">
.education-page {
  height: 100%;

  &__loading {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__container {
    position: relative;
    width: 100%;
    max-width: 767px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 32px;
  }

  &__heading {
    font-size: 1.5rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif !important;
    margin-bottom: 20px;
  }

  &__description-heading {
    font-size: 1rem;
    line-height: 1.5;
    font-weight: 600;
    color: #000000;
  }

  &__description {
    margin-bottom: 20px;

    .image {
      img {
        max-width: 100%;
        height: auto;
      }
    }
  }

  &__images {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 16px;
    margin: 16px 0;
  }

  &__child-pages {
    position: relative;
    top: 38px;
    background-color: $primary;
  }

  &__child-pages-heading {
    color: #FFFFFF;
    font-size: 1rem;
    font-weight: bold;
    padding: 8px;
    margin-bottom: 0;

    @media screen and (min-width: 960px) {
      padding-left: calc((100vw - 256px - 750px) / 2) !important;
    }
  }

  &__child-pages-list {
    background-color: #90cae8;
    list-style-type: none;
    padding: 0 !important;
  }

  &__child-pages-list-item {
    background-color: #90cae8;
    padding: 8px;
    border-bottom: 2px solid white;

    @media screen and (min-width: 960px) {
      padding-left: calc((100vw - 256px - 750px) / 2) !important;
    }

    &:first-child {
      border-top: 2px solid white;
    }

    &:last-child {
      border-bottom: 0px;
    }
  }

  &__child-pages-list-item-link {
    text-decoration: none;
    color: black !important;

    &:focus {
      outline: none;
      text-decoration: underline;
    }
  }

  .container {
    height: 100%;
  }
}
</style>